import React from 'react';
import classNames from 'classnames';
import styles from './ProgressIndicator.module.scss';

export interface ProgressIndicatorProps {
  percentage: number;
  sum?: number;
  progress?: number;
  rowLayout?: boolean;
  hideMaxIndicator?: boolean;
  type?: 'brand' | 'default';
  size?: 'large' | 'default';
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  percentage,
  sum,
  progress,
  rowLayout = false,
  hideMaxIndicator = false,
  type = 'default',
  size = 'default',
}) => {
  const colorCode = {
    'status-error-full': percentage < 50,
    'status-warning-full': percentage >= 50 && percentage < 80,
    'status-success-full': percentage >= 80,
  };

  return (
    <div
      className={classNames(styles.root, {
        [styles.rowLayout]: rowLayout,
      })}>
      <div
        className={classNames(
          styles.bar,
          type === 'brand'
            ? 'surface-active'
            : {
                'status-error-surface': percentage < 50,
                'status-warning-surface': percentage >= 50 && percentage < 80,
                'status-success-surface': percentage >= 80,
              },
          size === 'large' ? 'h-3 w-full' : 'h-[0.4rem] w-[6.4rem]',
        )}>
        <div
          className={classNames(
            styles.progress,
            type === 'brand' ? 'brand surface-primary' : colorCode,
            size === 'large' ? 'h-3' : 'h-[0.4rem]',
          )}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <span className={classNames('typo-text-12', type === 'brand' ? 'text-faded' : colorCode)}>
        {(() => {
          if (sum !== undefined && progress !== undefined) {
            return `${progress}/${sum}`;
          }
          if (hideMaxIndicator) {
            return `${percentage}%`;
          }
          return `${percentage}/100`;
        })()}
      </span>
    </div>
  );
};

export default ProgressIndicator;
